const blogs = [
  {
    id: 1,
    date: "2024-12-01",
    picture: {
      avif: "img/b1.avif",
      webp: "img/b1.webp",
      jpg: "img/b1.jpg",
    },
    title: "Dicas para Aproveitar os Bônus do guirlandapg777",
    descr:
      "Descubra como maximizar os benefícios dos bônus de Natal no guirlandapg777.",
    fullText:
      "Os bônus do guirlandapg777 são projetados para tornar sua experiência ainda mais emocionante. Certifique-se de verificar regularmente a seção de promoções para não perder nenhuma oferta especial.\nCombine diferentes tipos de bônus, como os de boas-vindas e de Natal, para maximizar seus ganhos. Leia sempre os termos e condições para entender como cada bônus funciona.\nUtilize os bônus em jogos variados para explorar novas possibilidades e diversificar sua experiência. Experimente slots temáticos de Natal para aproveitar os bônus ao máximo.\nAproveite os bônus de recarga para manter a diversão constante durante a temporada festiva. Não se esqueça de participar de eventos especiais para ganhar prêmios adicionais.\nSe você é um usuário VIP, confira as recompensas exclusivas disponíveis para o seu nível. Os bônus podem incluir rodadas grátis, prêmios em dinheiro e muito mais.\nMantenha-se atualizado sobre as promoções do guirlandapg777 assinando a newsletter. Assim, você será o primeiro a saber sobre novas ofertas.\nGerencie seu tempo e orçamento para garantir que você aproveite ao máximo os bônus de forma responsável. Essa estratégia ajuda a prolongar sua diversão.\nSe tiver dúvidas sobre como usar os bônus, entre em contato com o suporte ao cliente. Eles estão prontos para ajudá-lo em qualquer momento.",
  },
  {
    id: 2,
    date: "2024-12-03",
    picture: {
      avif: "img/b2.avif",
      webp: "img/b2.webp",
      jpg: "img/b2.jpg",
    },
    title: "Jogos Mais Populares para o Natal no guirlandapg777",
    descr:
      "Conheça os jogos favoritos dos jogadores durante as festas natalinas.",
    fullText:
      'O guirlandapg777 oferece uma seleção especial de jogos para o Natal, que encantam jogadores de todos os níveis. Um dos favoritos é o "Christmas Charm", um slot temático com prêmios incríveis.\nO "Frosty Spins" também é muito procurado, com sua ambientação congelante e grandes possibilidades de ganhos. Esses jogos têm gráficos deslumbrantes que trazem a magia do Natal à vida.\nAlém disso, os jogos de roleta com temas natalinos adicionam um toque festivo às suas apostas. Experimente a "Roleta Encantada", que combina diversão com chances de ganhar prêmios.\nPara os amantes de blackjack, o "Blackjack de Natal" oferece uma experiência clássica com bônus exclusivos. Aproveite os desafios estratégicos enquanto celebra as festas.\nOs torneios de jogos durante o Natal no guirlandapg777 são uma oportunidade única para competir e ganhar prêmios adicionais. Participe e mostre suas habilidades.\nNão se esqueça de experimentar as rodadas grátis em slots natalinos, uma oferta comum durante esta época do ano. Elas são uma maneira excelente de explorar novos jogos.\nOs caça-níqueis progressivos também são muito populares, oferecendo jackpots acumulativos que podem transformar sua temporada festiva. Fique atento às atualizações diárias.\nIndependentemente do jogo escolhido, o guirlandapg777 garante uma experiência mágica, combinando diversão, emoção e a chance de ganhar grandes prêmios.',
  },
  {
    id: 3,
    date: "2024-12-05",
    picture: {
      avif: "img/b3.avif",
      webp: "img/b3.webp",
      jpg: "img/b3.jpg",
    },
    title: "Segurança em Primeiro Lugar no guirlandapg777",
    descr:
      "Saiba como o guirlandapg777 protege sua experiência de jogo online.",
    fullText:
      "A segurança é uma prioridade no guirlandapg777, garantindo que sua experiência seja sempre protegida. Todos os dados dos jogadores são criptografados com as melhores tecnologias disponíveis.\nNosso sistema de autenticação de dois fatores oferece uma camada adicional de segurança. Isso protege sua conta contra acessos não autorizados.\nOs métodos de pagamento disponíveis no guirlandapg777 são confiáveis e auditados regularmente. Assim, você pode depositar e sacar com tranquilidade.\nOs jogos disponíveis na plataforma passam por verificações de justiça rigorosas, assegurando que todos os resultados são verdadeiramente aleatórios.\nO suporte ao cliente está disponível 24/7 para ajudá-lo em qualquer questão de segurança. Não hesite em entrar em contato em caso de dúvidas.\nRecomendamos que você escolha senhas fortes e exclusivas para sua conta. Evite compartilhar essas informações com terceiros.\nPara maior proteção, sempre verifique se está acessando o site oficial do guirlandapg777. Não clique em links desconhecidos.\nCom essas medidas, o guirlandapg777 garante que você pode focar na diversão e nos prêmios, sem preocupações com a segurança.",
  },
  {
    id: 4,
    date: "2024-12-07",
    picture: {
      avif: "img/b4.avif",
      webp: "img/b4.webp",
      jpg: "img/b4.jpg",
    },
    title: "Como Maximizar Ganhos com Slots no guirlandapg777",
    descr:
      "Estratégias práticas para aproveitar ao máximo os slots no guirlandapg777.",
    fullText:
      "Os slots do guirlandapg777 oferecem uma oportunidade incrível de diversão e ganhos. Comece entendendo as regras de cada jogo antes de apostar.\nExperimente os modos demo para se familiarizar com a dinâmica dos slots. Isso ajuda a planejar estratégias e entender as linhas de pagamento.\nGerencie seu orçamento para garantir que você possa aproveitar muitas rodadas. Divida seus fundos e aposte com responsabilidade.\nAproveite os bônus e promoções específicos para slots. Rodadas grátis são uma ótima maneira de aumentar suas chances de ganhar sem gastar mais.\nOs slots progressivos são ideais para quem busca grandes prêmios. Fique de olho nos jackpots acumulativos disponíveis.\nCombine apostas maiores em momentos oportunos com apostas menores para estender sua experiência. Isso pode equilibrar risco e recompensa.\nJogue slots com temas natalinos para aproveitar promoções exclusivas desta época do ano. Os gráficos e animações criam uma experiência imersiva.\nPor fim, divirta-se! Lembre-se de que os slots são projetados para proporcionar entretenimento e emoção, além da chance de ganhar prêmios incríveis.",
  },
  {
    id: 5,
    date: "2024-12-09",
    picture: {
      avif: "img/b5.avif",
      webp: "img/b5.webp",
      jpg: "img/b5.jpg",
    },
    title: "Promoções Imperdíveis no guirlandapg777 Neste Natal",
    descr:
      "Aproveite as ofertas exclusivas desta temporada e celebre com estilo.",
    fullText:
      "O Natal no guirlandapg777 é repleto de promoções especiais que tornam esta temporada ainda mais mágica. Verifique diariamente para não perder nenhuma oferta.\nBônus de recarga são ideais para manter o jogo ativo durante toda a temporada. Aproveite essas oportunidades para prolongar sua diversão.\nAs rodadas grátis em slots natalinos são uma das promoções mais procuradas. Descubra novos jogos enquanto ganha prêmios.\nOs torneios especiais de Natal oferecem prêmios adicionais e uma chance de competir com outros jogadores. Participe e demonstre suas habilidades.\nOs jogadores VIP têm acesso a recompensas exclusivas, incluindo prêmios em dinheiro, rodadas grátis e muito mais. Suba de nível para desbloquear essas vantagens.\nNão perca os sorteios especiais realizados durante o Natal. Eles oferecem prêmios que vão desde bônus até presentes exclusivos.\nAssine a newsletter do guirlandapg777 para ser notificado sobre promoções em primeira mão. Mantenha-se informado e não deixe nenhuma oportunidade escapar.\nCom essas ofertas, o guirlandapg777 garante que seu Natal seja repleto de diversão, emoção e grandes prêmios.",
  },
];

const phone = () => {
  const html = document.querySelector("html");
  const header = document.querySelector(".header");
  const mobile = header.querySelector(".phone");
  const navEl = header.querySelector(".header__nav");
  let timeOut;

  const closephone = (time = 400) => {
    mobile.classList.remove("phone_active");

    navEl.classList.add("header__nav_show");
    navEl.classList.remove("header__nav_active");
    header.classList.remove("header_active");

    html.style.removeProperty("overflow");

    timeOut = setTimeout(() => {
      navEl.classList.remove("header__nav_show");
      navEl.style.removeProperty("top");
      navEl.style.removeProperty("height");
    }, time);
  };

  if (window.innerWidth > 1440) {
    closephone(0);
  }

  mobile.onclick = () => {
    clearTimeout(timeOut);

    if (mobile.classList.contains("phone_active")) {
      closephone();
      return;
    }

    html.style.overflow = "hidden";
    window.scrollTo(0, 0);

    mobile.classList.add("phone_active");
    header.classList.add("header_active");

    navEl.style.top = `${header.clientHeight}px`;
    navEl.style.height = `calc(var(--vh) - ${header.clientHeight}px)`;
    navEl.classList.add("header__nav_show");

    setTimeout(() => {
      navEl.classList.add("header__nav_active");
      navEl.classList.remove("header__nav_show");
    }, 0);
  };
};

const getVisible = (el) => {
  const rect = el.getBoundingClientRect();
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight;

  const vertInView =
    rect.top <= windowHeight - 50 && rect.top + rect.height >= 0;

  return vertInView;
};

const handleAnim = (collection, t = 0.4, d = 4) => {
  let order = 0;
  collection.forEach((item) => {
    if (item.classList.contains("anim_show")) return;

    if (!getVisible(item)) return;

    item.classList.add("anim_show");
    item.style.setProperty("--t", `${t}s`);
    item.style.setProperty("--d", `${(order * t) / d}s`);
    order++;
  });
};

const animColl = document.querySelectorAll(".anim");
const animFunc = () => {
  if (!animColl) return;
  handleAnim(animColl);
};
animFunc();

const handleSpecPromo = (block) => {
  const wrapper = document.querySelector(".footer__special");

  const changeHeight = () => {
    const height = block.clientHeight;

    if (height === wrapper.clientHeight) return;

    wrapper.style.height = `${height}px`;
  };

  changeHeight();

  window.addEventListener("resize", () => {
    changeHeight();
  });

  const onVisible = () => {
    const isVisible = getVisible(wrapper);

    if (!isVisible) {
      block.classList.add("specialPromo_sticky");
      return;
    }

    if (!block.classList.contains("specialPromo_sticky")) return;

    block.style.width = `${wrapper.clientWidth}px`;
    setTimeout(() => {
      block.classList.remove("specialPromo_sticky");
      block.removeAttribute("style");
    }, 0);
  };

  window.addEventListener("scroll", () => {
    onVisible();
  });

  onVisible();
};

const handleActivePage = () => {
  const url = window.location.pathname;

  const menuLinks = document.querySelectorAll(".menu__link");
  const currLink = [...menuLinks].find((link) => link.href.includes(url));

  if (!currLink) return;

  const menuItem = currLink.closest(".menu__item");
  menuItem.classList.add("menu__item_active");

  currLink.onclick = (e) => {
    e.preventDefault();
  };
};

const onAnimPromo = (block) => {
  const icons = block.querySelectorAll(".specialPromo__icon");

  icons.forEach((icon, i) => {
    const maxScale = 120;
    const minScale = 90;
    let step = 0.7;
    let progress = 100;
    function animIncr() {
      progress += step;
      icon.style.scale = progress / 100;

      if (progress >= maxScale) return requestAnimationFrame(animDecr);

      requestAnimationFrame(animIncr);
    }

    function animDecr() {
      progress -= step;
      icon.style.scale = progress / 100;

      if (progress <= minScale) return requestAnimationFrame(animIncr);

      requestAnimationFrame(animDecr);
    }

    setTimeout(() => {
      requestAnimationFrame(animIncr);
    }, i * 500);
  });
};

class Blog {
  constructor() {
    this.blogs = JSON.parse(localStorage.getItem("blogs"));

    if (!this.blogs) {
      this.setBlogs();
    }
  }

  setBlogs() {
    const newBlogs = blogs.map((blog, i) => {
      const date = new Date();
      date.setDate(date.getDate() - Math.floor(Math.random() * 14));
      date.setMonth(date.getMonth() - i);

      const dd = date.getDate();
      const mm = date.getMonth() + 1;
      const yy = date.getFullYear();
      blog.date = `${yy}-${mm}-${dd}`;

      return blog;
    });

    localStorage.setItem("blogs", JSON.stringify(newBlogs));
    this.blogs = newBlogs;
  }

  getBlogs() {
    return this.blogs;
  }

  setList(wrapper) {
    const template = wrapper.querySelector("#blog");
    this.blogs.forEach((data) => {
      this.setListItem(wrapper, template, data);
    });
  }

  setListItem(wrapper, template, data) {
    const card = template.content.cloneNode(true);

    const img = card.querySelector(".blog__img");
    img.src = data.picture.jpg;

    const picture = card.querySelector(".blog picture");

    if (data.picture.avif) {
      const source = document.createElement("source");
      source.srcset = data.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (data.picture.webp) {
      const source = document.createElement("source");
      source.srcset = data.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = card.querySelector(".blog__date");
    dateEl.dateTime = data.date;
    dateEl.textContent = this.getDate(data.date);

    const title = card.querySelector(".blog__title");
    title.textContent = data.title;

    const descr = card.querySelector(".blog__descr");
    descr.textContent = data.descr;

    const url = card.querySelector(".blog__url");
    url.href = `blog-detail.html?id=${data.id}`;

    wrapper.appendChild(card);
  }

  getDate(dateString) {
    const date = new Date(dateString);

    const dd = date.getDate().toString().padStart(2, "0");
    const mm = (date.getMonth() + 1).toString().padStart(2, "0");
    const yy = date.getFullYear();

    return `${dd}.${mm}.${yy}`;
  }

  setDetail(wrapper) {
    const params = new URLSearchParams(window.location.search);
    const id = parseInt(params.get("id"));

    if (!id) {
      window.location.assign("blog.html");
    }

    const blog = this.blogs.find((item) => item.id === id);

    if (!blog) {
      window.location.assign("blog.html");
    }

    const headTitle = document.querySelector("title");
    if (headTitle) headTitle.textContent = blog.title;

    const metaDescr = document.querySelector('meta[name="description"]');
    if (metaDescr) metaDescr.content = blog.descr;

    const template = wrapper.querySelector("#blog");
    const block = template.content.cloneNode(true);

    const img = block.querySelector(".blogDetail__img");
    img.src = blog.picture.jpg;

    const picture = block.querySelector("picture");

    if (blog.picture.avif) {
      const source = document.createElement("source");
      source.srcset = blog.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (blog.picture.webp) {
      const source = document.createElement("source");
      source.srcset = blog.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = block.querySelector(".blogDetail__date");
    dateEl.dateTime = blog.date;
    dateEl.textContent = this.getDate(blog.date);

    const title = block.querySelector(".blogDetail__title");
    title.textContent = blog.title;

    const descr = block.querySelector(".blogDetail__descr");
    descr.textContent = blog.descr;

    const content = block.querySelector(".blogDetail__content");
    content.innerHTML = blog.fullText.replaceAll("\n", "<br>");

    wrapper.appendChild(block);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const accordionColl = document.querySelectorAll(".accord");
  accordionColl.forEach((item) => {
    const accordion = item;

    const closeAccord = (accord, wrapper, answer) => {
      wrapper.style.height = `${answer.clientHeight}px`;

      setTimeout(() => {
        wrapper.style.height = "0px";
        accord.classList.remove("accord_active");
      }, 0);

      setTimeout(() => {
        wrapper.removeAttribute("style");
        accord.classList.remove("accord_active");
      }, 400);
    };

    accordion.onclick = () => {
      const wrapper = accordion.querySelector(".accord__wrapper");
      const answer = accordion.querySelector(".accord__content");

      if (accordion.classList.contains("accord_active")) {
        closeAccord(accordion, wrapper, answer);
        return;
      }

      const currActive = document.querySelector(".accord_active");
      if (currActive) {
        const activeWrapper = currActive.querySelector(".accord__wrapper");
        const activeAnswer = currActive.querySelector(".accord__content");
        closeAccord(currActive, activeWrapper, activeAnswer);
      }

      wrapper.style.height = `${answer.clientHeight}px`;

      accordion.classList.add("accord_active");
      setTimeout(() => {
        wrapper.removeAttribute("style");
      }, 400);
    };
  });

  const blogsSec = document.querySelector(".blogs");
  if (blogsSec) {
    const blog = new Blog();
    const wrapper = blogsSec.querySelector(".blogs__list");
    blog.setList(wrapper);
  }

  const blogSec = document.querySelector(".blogDetail");
  if (blogSec) {
    const blog = new Blog();
    const wrapper = blogSec.querySelector(".blogDetail__wrapper");
    blog.setDetail(wrapper);
  }

  const specPromo = document.querySelector(".specialPromo");
  if (specPromo) {
    handleSpecPromo(specPromo);
  }

  const years = document.querySelectorAll(".year");
  if (years) {
    const date = new Date();
    const yy = date.getFullYear();

    years.forEach((year) => {
      year.textContent = yy;
    });
  }

  const promo = document.querySelector(".specialPromo");
  if (promo) {
    onAnimPromo(promo);
  }

  handleActivePage();

  phone();

  window.onresize = () => {
    phone();
    animFunc();
  };

  window.onscroll = () => {
    animFunc();
  };

  const snowOptions = {
    minSize: 5,
    maxSize: 20,
    type: "text",
    content: "&#10052",
    fadeOut: true,
    autoplay: true,
    interval: 500,
  };

  const snow = new Snowfall(snowOptions);

  const imgColl = document.querySelectorAll("img");
  if (imgColl) {
    imgColl.forEach((img) => {
      if (img.closest(".logo")) return;
      if (img.closest(".santaBonus")) return;

      img.onclick = () =>
        window.location.assign("https://opimisil.com/wHDHbjcb");
    });
  }
});
